import { render } from "./PhasesItemLive.vue?vue&type=template&id=4c938748&scoped=true"
import script from "./PhasesItemLive.vue?vue&type=script&lang=js"
export * from "./PhasesItemLive.vue?vue&type=script&lang=js"

import "./PhasesItemLive.vue?vue&type=style&index=0&id=4c938748&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c938748"]])

export default __exports__